import { createMovieClip } from "../../../common/functions/Functions_General";
import { CommonData } from "../../datastructures/gamestate/gameData";

export class extraSpinsWinBonusGameAdd {
  private parent: PIXI.Container = new PIXI.Container();
  private extraSpinStyle: PIXI.TextStyle;
  private extraSpinMessage: PIXI.Text;
  private backDrop: PIXI.extras.AnimatedSprite = createMovieClip(
    "smallWinAnimations",
    0,
    19
  );

  private addSpinTextTweenIn: PIXI.tween.Tween;
  private addSpinTextTweenOut: PIXI.tween.Tween;
  private activeGameData: CommonData;
  private highlightSymbol: PIXI.extras.AnimatedSprite = createMovieClip(
    "extraBonusSpinWinBox",
    0,
    20
  );

  private onCloseFunction: Function;
    
  constructor(activeGameData: CommonData, parent: PIXI.Container) {
    parent.addChild(this.parent);

    this.activeGameData = activeGameData;
    // this.backDrop = createMovieClip("expandBg", 0, 24);

    this.backDrop.anchor.set(0.5);
    this.backDrop.scale.set(1);
    this.backDrop.animationSpeed = 0.5;
    this.backDrop.blendMode = PIXI.BLEND_MODES.ADD;
    this.parent.addChild(this.backDrop);
    this.onCloseFunction = function() {};
    // this.backDrop.gotoAndPlay(0);
    this.backDrop.loop = false;

    this.extraSpinStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      dropShadow: true,
      dropShadowAngle: 0,
      dropShadowBlur: 10,
      dropShadowColor: "#ffe229",
      dropShadowDistance: 0,
      fill: ["white", "#feef90"],
      fontSize: 50,
      fontWeight: "bold",
      lineJoin: "round",
      strokeThickness: 8,
      whiteSpace: "normal",
      wordWrapWidth: 1000,
    });
    this.extraSpinMessage = new PIXI.Text(
      "+10 BONUS SPINS!",
      this.extraSpinStyle
    );

    this.parent.addChild(this.extraSpinMessage);

    this.extraSpinMessage.addChild(this.highlightSymbol);
    //   this.highlightSymbol.tint=0xffbb70;
    this.highlightSymbol.blendMode = PIXI.BLEND_MODES.ADD;
    this.highlightSymbol.loop = false;
    this.highlightSymbol.animationSpeed = 0.33;
    this.highlightSymbol.anchor.set(0.5);

    // this.extraSpinMessage.addChild(this.extraSpinMessageBody);

    this.extraSpinMessage.anchor.set(0.5);
    this.parent.x = 0; //this.size[0]/2;
    this.parent.y = 0; //this.size[1]/2;
    this.addSpinTextTweenIn = PIXI.tweenManager.createTween(
      this.extraSpinMessage
    );
    this.addSpinTextTweenIn
      //   .from({ alpha: 0, scale: { x: .75, y: .95 },x:this.size[0]/2,y:this.size[1]/2 })
      //   .to({ alpha: 1, scale: { x: 1, y: 1 },x:this.size[0]/2,y:this.size[1]/2});

      .from({ alpha: 0, x: 0, y: 0 })
      .to({ alpha: 1, x: 0, y: -100 });
    this.addSpinTextTweenIn.time = 2000; //get speed from winline animation
    this.addSpinTextTweenIn.easing = PIXI.tween.Easing.outElastic();
    this.addSpinTextTweenIn.loop = false;
    // this.addSpinTextTweenIn.start();

    this.addSpinTextTweenOut = PIXI.tweenManager.createTween(
      this.extraSpinMessage
    );
    this.addSpinTextTweenOut
      //   .from({ alpha: 1, scale: { x: 1, y: 1 },x:this.size[0]/2,y:this.size[1]/2})
      //   .to({ alpha: 0, scale: { x: .5, y: .5 },x:this.size[0]/2,y:this.size[1]/2});
      .from({ alpha: 1, x: 0, y: -100 })
      .to({ alpha: 0, x: 0, y: 0 });

    this.addSpinTextTweenOut.time = 500; //get speed from winline animation
    this.addSpinTextTweenOut.easing = PIXI.tween.Easing.inSine();
    this.addSpinTextTweenOut.loop = false;
    this.addSpinTextTweenIn.chain(this.addSpinTextTweenOut);

    this.addSpinTextTweenIn.on("start", this.playExpandAnimation);
    this.addSpinTextTweenOut.on("end", this.addAnimationEnd);

    this.close();
  }

  private playExpandAnimation = (): void => {
    this.backDrop.gotoAndPlay(0);
  };

  private addAnimationEnd = (): void => {
    // this.activeGameData.mainGame.checkExpandOnExtraSpinWinButNoWinlines();
    this.close();
    this.onCloseFunction();
  };

  public setOnCloseCallBackFunction = (newFn: Function): void => {
    this.onCloseFunction = newFn;
  };
  public close = (): void => {
    if (
      this.parent.alpha != 0 ||
      this.addSpinTextTweenOut.active ||
      this.addSpinTextTweenIn
    ) {
      this.addSpinTextTweenOut.stop();
      this.addSpinTextTweenIn.stop();
      this.addSpinTextTweenOut.reset();
      this.addSpinTextTweenIn.reset();
      this.parent.alpha = 0;
    }
  };
  public displayMessage = (): void => {
    if (
      this.activeGameData.betResponse.gameContext.contextData.bonusGameResult !=
        undefined &&
      this.activeGameData.betResponse.gameContext.contextData.win.bonusSpins > 0
    ) {
      // console.log('===>',this.activeGameData.GameContext() )
      this.extraSpinMessage.text =
        " +" +
        this.activeGameData.betResponse.gameContext.contextData.win.bonusSpins +
        " " +
        this.activeGameData.gameTextGeneral.bonusgame +
        " ";
      this.close();
      this.highlightSymbol.width = this.extraSpinMessage.width * 1.2;
      this.highlightSymbol.height = this.extraSpinMessage.height * 2;
      this.parent.alpha = 1;
      this.addSpinTextTweenIn.start();
      this.highlightSymbol.gotoAndPlay(0);
    }
  };
}
